import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'

const AssemblyIDSearchModal = ({ isVisible, onClose, handleAssemblyIDSearch }) => {
    const [searchTerm, setSearchTerm] = useState('')
    // If the modal is not visible, return null (do not render)
    if (!isVisible) {
        return null
    }

    const handleInputChange = (event) => {
        setSearchTerm(event.target.value)
    }

    return (
        <Modal
            show={true}
            backdropClassName='veil'
            animation={false}
            centered
            autoFocus={false}
            onHide={onClose}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'inline-block' }}>Enter Awc ID</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input
                    type='Search Awc ID'
                    placeholder='Enter Awc ID'
                    onChange={handleInputChange}
                    style={{ padding: '10px', width: '70%' }}
                />
                <button
                    onClick={() => {
                        handleAssemblyIDSearch(searchTerm)
                        onClose()
                    }}
                    style={{ marginTop: '10px' }}
                >
                    Search
                </button>
            </Modal.Body>
        </Modal>
    )
}

export default AssemblyIDSearchModal
